module.exports = __webpack_public_path__ + "img/avar.b7d391f2.jpg";